// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartSection {
    border-radius: var(--border-radius);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);
    /* background-color: #ffffff; */
    background-clip: border-box;
    border: 1px solid var(--border-color);
}

.chartDropDown {
    position: absolute;
    right: 30px;
    top: 20px;
}

.chartWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 30px;
}

.chartWrapperLastBlock {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
}


.lineChart {
    color: #ced4da;
    font-size: 12px;
}

.topfiveStoreListWrapper {
    margin-top: 10px;
    width: 100%;
    padding-left: 35px;
}

.tableWrapper table tbody tr .storeLogo img {
    /* height: 40px; */
    width: 40px;
    /* object-fit: cover; */
    /* border-radius: 10px; */
}

.topfiveStoreListWrapper .tableWrapper {
    padding: 10px 0;
}

.individualChartBlock {
    /* width: 50%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.chartTitle {
    /* margin-left: -280px; */
    display: flex;
    justify-content: start;
    align-items: start;
    margin-bottom: 10px;
}

.topfiveStoreListWrapper thead th {
    width: 40%;
}

.topfiveStoreListWrapper span {
    display: flex;
    justify-content: start;
    align-items: initial;
    font-size: 15px;
    font-weight: 500
}

.pieChartWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
}

.store_block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 350px;
}

.chartWrapper_stores {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 30px;
}

.chartWrapper_stores .card p {
    display: flex;
    font-size: 20px;
    padding: 16px;
}

.chartWrapper_stores .card {
    box-shadow: #ced4da;
}

.select_store p {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.store_logo_and_store_name {
    display: flex;
    align-items: center;
}

.top_store_name_as_logo {
    width: 40px;
    height: 40px;
    background-color: #ececec;
    color: #9d9d9d;
    font-size: 14px;
    text-align: center;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
}

#my-line-chart .nivo-axis__axis-bottom text {
    color: transparent;
  }
  

  .chartWrapper .card{
    width: 49%;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/GlobalAdminDashboard/GlobalAdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,+BAA+B;IAC/B,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;EACpB;;;EAGA;IACE,UAAU;EACZ","sourcesContent":[".chartSection {\n    border-radius: var(--border-radius);\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.03);\n    /* background-color: #ffffff; */\n    background-clip: border-box;\n    border: 1px solid var(--border-color);\n}\n\n.chartDropDown {\n    position: absolute;\n    right: 30px;\n    top: 20px;\n}\n\n.chartWrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-bottom: 30px;\n}\n\n.chartWrapperLastBlock {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0px;\n}\n\n\n.lineChart {\n    color: #ced4da;\n    font-size: 12px;\n}\n\n.topfiveStoreListWrapper {\n    margin-top: 10px;\n    width: 100%;\n    padding-left: 35px;\n}\n\n.tableWrapper table tbody tr .storeLogo img {\n    /* height: 40px; */\n    width: 40px;\n    /* object-fit: cover; */\n    /* border-radius: 10px; */\n}\n\n.topfiveStoreListWrapper .tableWrapper {\n    padding: 10px 0;\n}\n\n.individualChartBlock {\n    /* width: 50%; */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.chartTitle {\n    /* margin-left: -280px; */\n    display: flex;\n    justify-content: start;\n    align-items: start;\n    margin-bottom: 10px;\n}\n\n.topfiveStoreListWrapper thead th {\n    width: 40%;\n}\n\n.topfiveStoreListWrapper span {\n    display: flex;\n    justify-content: start;\n    align-items: initial;\n    font-size: 15px;\n    font-weight: 500\n}\n\n.pieChartWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.store_block {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 350px;\n}\n\n.chartWrapper_stores {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 30px;\n}\n\n.chartWrapper_stores .card p {\n    display: flex;\n    font-size: 20px;\n    padding: 16px;\n}\n\n.chartWrapper_stores .card {\n    box-shadow: #ced4da;\n}\n\n.select_store p {\n    height: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.store_logo_and_store_name {\n    display: flex;\n    align-items: center;\n}\n\n.top_store_name_as_logo {\n    width: 40px;\n    height: 40px;\n    background-color: #ececec;\n    color: #9d9d9d;\n    font-size: 14px;\n    text-align: center;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n}\n\n#my-line-chart .nivo-axis__axis-bottom text {\n    color: transparent;\n  }\n  \n\n  .chartWrapper .card{\n    width: 49%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
